var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaAugenoptik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f0e4d6;}.cls-3{fill:#a3ccee;}.cls-4{fill:#282828;}.cls-5{fill:#e8dccf;}.cls-6{fill:#009bd9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    "data-name": "SVGCleanerId 0",
    className: "cls-2",
    d: "M8,80H8a85.11,85.11,0,0,1,144,0h0A85.11,85.11,0,0,1,8,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-2",
    "data-name": "SVGCleanerId 0",
    className: "cls-2",
    d: "M8,80H8a85.11,85.11,0,0,1,144,0h0A85.11,85.11,0,0,1,8,80Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 80,
    cy: 80,
    r: 39.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.52,
    y: 17.93,
    width: 4.97,
    height: 39.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 17.93,
    y: 77.52,
    width: 39.72,
    height: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.52,
    y: 102.35,
    width: 4.97,
    height: 39.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.9,40.28h-5V20.41a2.48,2.48,0,0,1,2.48-2.48H40.28v5H22.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.07,40.28h-5V22.9H119.72v-5h19.87a2.48,2.48,0,0,1,2.48,2.48V40.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.59,142.07H119.72v-5H137.1V119.72h5v19.87A2.48,2.48,0,0,1,139.59,142.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.28,142.07H20.41a2.48,2.48,0,0,1-2.48-2.48V119.72h5V137.1H40.28v5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.45,54q-5.1,4.71-10.63,8.91A39.64,39.64,0,0,1,80,119.72,84.39,84.39,0,0,0,152,80h0A84.62,84.62,0,0,0,126.45,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.41,97.56C38.53,99.33,33,100.81,28,102a84.84,84.84,0,0,0,52,17.7A39.67,39.67,0,0,1,44.41,97.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.72,80a39.48,39.48,0,0,0-3.9-17.09C93.3,80.05,66.5,90.89,44.41,97.56A39.7,39.7,0,0,0,119.72,80Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 80,
    cy: 80,
    r: 14.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 102.35,
    y: 77.52,
    width: 39.72,
    height: 4.97
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaAugenoptik);
export default __webpack_public_path__ + "static/media/ka_augenoptik.1f856ef09e2beb110bbf8d7dfdd69f59.svg";
export { ForwardRef as ReactComponent };